import { mapState } from 'vuex';
export default {
  name: 'ViewHelp',
  data: function () {
    return {
      helpPanels: null,
      generalQuestions: JSON.parse(`[
{
  "permission": "IsFmTicket.create",
  "q": "Meldung anlegen",
  "a": "Melde uns einfach Defekte, Beschädigungen oder Schmutz!<br>Du hast einen Defekt, Verschmutzung oder Beschädigungen entdeckt? Melde diese hier direkt der zuständigen Serviceperson mit einem Smartphone-Foto und weiteren Informationen. Wir kümmern uns sofort um deine Meldung!<br>Mache ein aussagekräftiges Foto von dem Mangel mit deinem Smartphone und lade es hoch."
}, {
  "permission": "IsFmTicket.read",
  "q": "Meldungsübersicht",
  "a": "Hier siehst Du alle Meldungen für deine Objekte. Diese Meldungen wurden durch Nutzer der Objekte erstellt. Du kannst die Meldungen hier einsehen, kommentieren und nach Erledigung in den Status „Fertig“ setzen. Wenn du mit der Bearbeitung einer Meldung beginnst, setze sie bitte auf den Status „In Arbeit“."
}, {
  "permission": "IsFmAccess.write",
  "q": "Digitaler Schlüsselbund",
  "a": "Hier findest du alle für dich freigegebenen digitalen Schlüssel. Du kannst einen Schlüssel direkt verwenden, indem du auf den Button in der entsprechenden Kachel drückst. Wenige Sekunden später wird die entsprechende Tür ein Piepen von sich geben und du kannst die Tür ver- oder entriegeln."
}, {
  "permission": "IsFmAccess.create",
  "q": "Schlüsselverwaltung",
  "a": "In dieser Anwendung kannst du Schlüssel erstellen. Jeder Eintrag in der Tabelle unten entspricht einem Schlüssel. Jeder Schlüssel ist einem System-Benutzer zugewiesen. Dieser findet den Schlüssel an seinem digitalen „Schlüsselbund“ und kann damit Türen ver- und entriegeln. Achte bei der Vergabe darauf, dass Schlüssel ohne Einschränkung oder zeitlich begrenzt gültig sein können."
}, {
  "permission": "DigitalTwin.manage",
  "q": "Digitale Zwillinge",
  "a": "Digitale Zwillinge (Digital Twins) sind digitale Abbilder von realen Dingen. Hier hast du Zugriff auf ein digitales Abbild der Objekte in deinem Konto."
}, {
  "permission": "DigitalTwin.manage",
  "q": "Aufbau der Digitalen Zwillinge",
  "a": "Hier findest du eine hierarchische Struktur aller Digitalen Zwillinge in deinem Konto. Wähle einen Zwilling aus, um ihn im Vorschau-Fenster zu betrachten."
}, {
  "permission": "DigitalTwin.manage",
  "q": "Digitaler Zwilling Vorschau",
  "a": "Vorschau auf den ausgewählten Zwilling: Mit den Buttons kannst du einen untergeordneten Zwilling anlegen oder den ausgewählten Zwilling editieren."
}, {
  "permission": "UserManagement.create",
  "q": "Konto-Verwaltung",
  "a": "Erstelle, aktualisiere oder lösche Konten, indem du ein Konto in der unten angeführten Baumansicht auswählst und es dann im Detailbereich rechts bearbeitest."
}, {
  "q": "Benutzer-Einstellungen",
  "a": "Hier kannst du deine Einstellungen verändern, z.B. eine neue Email-Adresse hinterlegen oder ein neues Passwort setzen. Deine Änderungen werden sofort aktiv."
}
]`),
      videos: JSON.parse(`[
{
  "title": "Allgemeine Einführung",
  "youtube": "diskvESjr94"
}, {
  "title": "Meldungen anlegen",
  "permission": "IsFmTicket.create",
  "youtube": "aY4bvUtgVnw"
}, {
  "title": "Meldungsübersicht",
  "permission": "IsFmTicket.read",
  "youtube": "ZHOkqLHlYPo"
}, {
  "title": "Digitaler Schlüsselbund",
  "youtube": "1hcLllMSdYI"
}, {
  "title": "Schlüsselverwaltung",
  "permission": "IsFmAccess.create",
  "youtube": "5H3c2wajyUk"
}]`),
      faqSections: JSON.parse(`[
{
  "title": "Allgemein",
  "questions": [
  {
    "q": "Wird die Handynummer zum Einrichten des Kontos benötigt?",
    "a": "Für die kombinierte Webapplikation zur Schließung per Mobiltelefon und dem digitalen Meldeportal wird keine Handynummer benötigt. Es reicht eine personalisierte E-Mail-Adresse.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Ist der Zugang individualisiert?",
    "a": "Jeder Schulhausmeister und jeder Objektmanager erhält seinen eigenen Zugang für den jeweiligen Standort. Objektmanager können mit ihrem Zugang alle Standorte, die in ihrer Verantwortung liegen sehen. Mitglieder von Sportvereinen werden einzeln für ihren Standort freigeschaltet, das heißt, Sportvereine erhalten keinen Gruppenzugang. ",
    "permission": "UserManagement.create"
  }, {
    "q": "Wie komme ich auf die Startseite? ",
    "a": "Die normale Startseite ist unter dem Link <a href=\\"https://sbh-iot.hamburg.de/\\" target=\\"_blank\\">sbh-iot.hamburg.de</a> aufrufbar.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Können Nutzer ihr Passwort selber wechseln?",
    "a": "Über das eigene Konto kann jeder sein Passwort selber wechseln.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Ist es möglich, die Schließung und das Meldeportal weiterhin zu nutzen, wenn man (vorübergehend) sein Mobiltelefon wechselt?",
    "a": "Ja. Die Webapplikation kann über ein anderes Mobiltelefon wieder über den Link <a href=\\"https://sbh-iot.hamburg.de/\\" target=\\"_blank\\">sbh-iot.hamburg.de</a> aufgerufen und durch Anmeldung mit seinen Zugangsdaten weitergenutzt werden.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Hat das Bezirksamt Zugang zur App und den hinterlegten Informationen?",
    "a": "Zurzeit ist die App nur für Mitarbeiter bei Schulbau Hamburg / Gebäudemanagement Hamburg (Schulhausmeister, Objektmanager, einzelne Mitarbeiter im ZFM) und aktive Sportler freigeschaltet. Während der Pilotphase wird nur ein Teil der Informationen für relevante Auswertungen an die Bezirksämter in zusammengefasster Form weitergegeben.",
    "permission": "UserManagement.create"
  }, {
    "q": "Können Hausmeistervertretungen aus Partnerschulen sowie Betriebsarbeiter Zugänge zur App erhalten?",
    "a": "Ja, dies ist möglich, bitte dazu eine E-Mail an fbsbhpilotsporthallen@sbh.hamburg.de schicken.",
    "permission": "UserManagement.create"
  }, {
    "q": "Sollte ein Schulhausmeister plötzlich ausfallen, wer hat außer ihm noch Zugang zur App und kann z.B. Schließzeiten vergeben?",
    "a": "Alle Objektmanager sind für die Vergabe von Schließzeiten für ihren Standort freigeschaltet, ggf. auch der Vertretungshausmeister und/oder ein Betriebsarbeiter.",
    "permission": "UserManagement.create"
  }, {
    "q": "Wer kann App-Aktivitäten bezogen auf einen Standort sehen (Systemlogging)? ",
    "a": "Nur übergeordnete Administratoren können aktuell sehen, wer sich z.B. wann eingeloggt hat oder eine Tür geschlossen hat.",
    "permission": "UserManagement.create"
  }, {
    "q": "Wann geht die Nutzerverwaltung an die Schulhausmeister über?",
    "a": "Ob und ab wann Schulhausmeister die Nutzerverwaltung übernehmen ist noch nicht entschieden.",
    "permission": "UserManagement.create"
  }, {
    "q": "Ist die App an ein Gerät gekoppelt?",
    "a": "Da es sich um eine Webapplikation handelt ist sie nicht an ein Gerät gekoppelt. Man kann sie daher z.B. beim Wechsel des Mobiltelefons durch seine E-Mail-Adresse wieder aktivieren. Dementsprechend ist man verpflichtet seine Zugangsdaten nicht an Dritte weiterzugeben.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Ist der Zugang individualisiert?",
    "a": "Mitglieder von Sportvereinen werden einzeln für ihren Standort freigeschaltet, das heißt, Sportvereine erhalten keinen Gruppenzugang. Da jeder Zugang durch eine individuelle E-Mail-Adresse erfolgt können zum Beispiel nicht mehrere Mitglieder eines Vereins eine gemeinsame Zugangsadresse nutzen. ",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Wie sieht der Informationsweg aus, wenn ein Verein neue Zeiten benötigt und somit für die App für neue Zeiten freigeschaltet werden soll?",
    "a": "Vereine regeln ihre Belegungszeiten weiterhin mit ihrem Ansprechpartner beim Bezirksamt. Sobald Änderungen in den Belegungszeiten offiziell bestätigt wurden programmiert der Schulhausmeister ggf. die Transponder um. Die Änderung der Schließzeiten in der App wird derzeit noch von Schulbau Hamburg übernommen, bitte schicke dazu eine E-Mail an fbsbhpilotsporthallen@sbh.hamburg.de ",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Hat das Bezirksamt Zugang zur App und den hinterlegten Informationen?",
    "a": "Zurzeit ist die App nur für Mitarbeiter bei Schulbau Hamburg / Gebäudemanagement Hamburg und aktive Sportler freigeschaltet. Während der Pilotphase wird nur ein Teil der Informationen für relevante Auswertungen an die Bezirksämter in zusammengefasster Form weitergegeben.",
    "permission": "IsFmTicket.create"
  }
  ]
}, {
  "title": "Schließung",
  "questions": [
  {
    "q": "Ist eine aktive Internetverbindung für die Nutzung der Schließung notwendig?",
    "a": "Ja, das Smartphone muss mit dem Internet verbunden sein, um die Haupteingangstür zu schließen.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Sind die Schulhausmeister dafür verantwortlich, bei Bedarf Schließzeiten in der App an ihrem Standort zu verändern?",
    "a": "Bis auf weiteres verläuft die Vergabe von Schließberechtigungen per Mobiltelefon zentral über Schulbau Hamburg (bitte E-Mail an: fbsbhpilotsporthallen@sbh.hamburg.de). Die Schulhausmeister sind aber weiterhin für die Zeitcodierung der Transponder zuständig.",
    "permission": "UserManagement.create"
  }, {
    "q": "Muss ich zum Verriegeln einer Tür auch noch zusätzlich den Zylinder drehen?",
    "a": "Je nach gegebenem Schließsystem ist dies der Fall. ",
    "permission": "UserManagement.create"
  }, {
    "q": "Wie sind die Ferienzeiten geregelt?",
    "a": "Die Zugangsfreischaltung ist bis auf weiteres durchgehend für jeden Nutzer geschaltet, d.h. aktuell gelten die Wochenzeiten auch für die Ferien.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Kann man bestimmte Personen für die Schließfunktion „sperren“ (z.B. bei Verdacht auf Missbrauch oder Ausscheiden aus dem Verein)?",
    "a": "Sobald Schulhausmeister die Schließfreigaben eigenständig regeln haben sie auch die Möglichkeit, einzelnen Nutzern an ihrem Standort eine vergebene Freigabe wieder zu entziehen.",
    "permission": "UserManagement.create"
  }, {
    "q": "Findet bei zwei parallelen Schließsystemen nicht eine doppelte Verwaltung statt? Wie soll man da den Überblick behalten?",
    "a": "Wir befinden uns mit der App in einer Testphase, in der wir erstmal die Akzeptanz und die Nützlichkeit mit einem kleinen Nutzerkreis testen möchten. Die App bietet uns technisch die Möglichkeit, weiterhin mit den normalen Transpondern zu schließen, so dass wir nicht jede Person, die an einem Standort einen Transponder besitzt umrüsten mussten. Die Freischaltungen in der App übernehmen wir zurzeit zentral, um Schulhausmeister zu entlasten. Da Sportler nach wie vor nur für ihre Trainingszeiten freigeschaltet sind ändert sich in den Zugangszeiten nicht viel. ",
    "permission": "UserManagement.create"
  }, {
    "q": "Ist die Verschlusssicherheit durch die App noch gewährleistet? ",
    "a": "Es liegt nach wie vor in der Verantwortung der Sportvereine, nach ihren Trainingszeiten die Türen zu verriegeln. Dies ist per App genauso möglich wie per Transponder.",
    "permission": "UserManagement.create"
  }, {
    "q": "Sind Sportstundenpläne zum Abgleich mit Schließzeiten integrierbar?",
    "a": "Aktuell lassen sich keine kompletten Belegungs- oder Stundenpläne in die App integrieren. ",
    "permission": "UserManagement.create"
  }, {
    "q": "Muss ich den Schulhausmeister ansprechen, wenn sich meine Trainingszeiten ändern?",
    "a": "Die Vergabe der Hallenzeit erfolgt wie gewohnt über die zuständigen Bezirksämter. Entsprechend der geschlossenen Nutzungsverträge verläuft die Vergabe von Schließberechtigungen per Mobiltelefon bis auf weiteres zentral über Schulbau Hamburg (bitte E-Mail an: fbsbhpilotsporthallen@sbh.hamburg.de). Die Schulhausmeister sind aber weiterhin für die Zeitcodierung der Transponder zuständig.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Wer öffnet die Tür, wenn der/die Hauptverantwortliche/r einer Trainingsgruppe aus einem bestimmten Grund dazu gerade nicht in der Lage ist?",
    "a": "Jede Trainingsgruppe wurde dazu ermuntert, bis zu zwei Vertreter zu nennen, die ebenfalls eine Schließberechtigung erhalten haben. Alternativ funktionieren auch weiterhin die vorhandenen Transponder.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Muss ich zum Verriegeln einer Tür auch noch zusätzlich den Zylinder drehen?",
    "a": "Je nach gegebenem Schließsystem ist dies der Fall. Türen müssen aus versicherungstechnischen Gründen grundsätzlich nach Beendigung der Trainingszeit verriegelt werden, außer, das System lässt eine Verriegelung nicht zu.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Kann ich bereits vor der im Nutzungsvertrag genannten Zeit in die Halle und kann ich sie im Anschluss noch nutzen?",
    "a": "Ihnen werden jeweils von und nach der vereinbarten Nutzungszeit 30 Minuten an Schließzeit zur Verfügung gestellt. Dies gilt auch bei einer Nutzung bis 24 Uhr.",
    "permission": "IsFmTicket.create"
  }
  ]
}, {
  "title": "Meldungen",
  "questions": [
  {
    "q": "Woran erkenne ich in der App, dass neue Meldungen für meinen Standort eingegangen sind?",
    "a": "In der oberen rechten Ecke gibt es ein Klingelsymbol, bei neuen Meldungen steht dort die Anzahl der neu eingegangenen, sowie aller Meldungen, die noch nicht als „fertig“ markiert wurden. Bei jeder neuen Meldung erhält ein Schulhausmeister zusätzlich durch das System als Erinnerung eine E-Mail.",
    "permission": "UserManagement.create"
  }, {
    "q": "Wer kann den Meldestatus sehen?",
    "a": "Den Meldestatus können Schulhausmeister und Objektmanager sehen. Meldungen können aber nur von Schulhausmeistern bearbeitet werden.",
    "permission": "UserManagement.create"
  }, {
    "q": "Erhält der Melder einer Störung eine Statusinformation?",
    "a": "Der Melder erhält aktuell nur eine Benachrichtigung, dass seine Meldung abgeschickt wurde.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Kann man (Gruppen-)Nachrichten an alle Nutzer seines Standortes schicken (z.B. wenn Sporthalle kurzfristig nicht benutzbar)?",
    "a": "Nachrichten an alle Nutzer zu schicken ist aktuell nicht möglich.",
    "permission": "UserManagement.create"
  }, {
    "q": "Ist eine aktive Internetverbindung für das Verfassen und Senden einer Schadensmeldung notwendig?",
    "a": "Ja, das Smartphone muss mit dem Internet verbunden sein, um die Schadensmeldung zu verfassen und zu senden.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Wenn Sportler eine Meldung absetzen – wie zeitverzögert darf die Meldung verschickt werden?",
    "a": "Die Meldung eines Schadens oder einer Verschmutzung sollte möglichst zeitnah (selber Tag) zur Entstehung oder Entdeckung erfolgen, damit ein schnelles Handeln möglich ist. ",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Soll z.B. auch gemeldet werden, wenn Hallen seit längerem von anderen Vereinen nicht genutzt werden, obwohl sie offiziell gebucht worden sind?",
    "a": "In erster Linie soll das Meldeportal dazu dienen, Schäden oder Verschmutzungen zu melden. Die Zuständigkeit Belegungspläne zu koordinieren liegt beim jeweiligen Bezirksamt, dieses soll dann auch informiert werden.",
    "permission": "IsFmTicket.create"
  }, {
    "q": "Entfällt nun die Notfallnummer?",
    "a": "Nein, die Notfallnummer, die in allen Sporthallen aushängt ist nach wie vor für alle akuten Notfälle gültig!",
    "permission": "IsFmTicket.create"
  }
  ]
}, {
  "title": "Datensicherheit",
  "questions": [
  {
    "q": "Wie werden die Daten verschlüsselt?",
    "a": "Die Login- und Nutzerdaten werden über HTTPS via SSL-256 verschlüsselt an den Server gesendet.",
    "permission": "UserManagement.create"
  }, {
    "q": "2-Stufen-Authentifizierung: Öffnung verknüpft an das Mobiltelefon?",
    "a": "Eine 2-Faktor-Authentifizierung ist derzeit nicht aktiviert. Die Authentifizierung des Nutzers erfolgt ausschließlich über die E-Mail-Adresse. ",
    "permission": "UserManagement.create"
  }, {
    "q": "Können von Personen Bewegungs-, bzw. Handlungsprofile erstellt werden? Können diese z.B. im Einbruchsfall der Polizei weitergegeben werden (auslesbares Schließprotokoll)?",
    "a": "Das System ist in der Lage, Protokolle zu erstellen, diese sind aber grundsätzlich nur bei begründeten Ausnahmen einseh- und auswertbar. Im Falle eines Einbruchs können diese an die Polizei weitergegeben werden. ",
    "permission": "UserManagement.create"
  }
  ]
}
]`)
    };
  },
  computed: {
    ...mapState('app', ['color', 'permissions']),
    generalQuestionsWithPermission() {
      return this.generalQuestions.filter(question => {
        return !question.permission || this.permissions[question.permission];
      });
    },
    videosWithPermission() {
      return this.videos.filter(video => {
        return !video.permission || this.permissions[video.permission];
      });
    },
    faqQuestionsWithPermission() {
      return this.faqSections.filter(section => {
        section.questions = section.questions.filter(question => {
          return this.permissions[question.permission];
        });
        return section.questions.length > 0;
      });
    }
  },
  methods: {
    hasUserPermissionForAnyQuestion(faqSection) {
      return faqSection.questions.find(question => {
        return this.permissions[question.permission];
      });
    }
  }
};